/**
 * Sets up the mutation observer to listen to changes on the DOM
 */
import { useEffect } from "react";
import { conditionsEngine } from "../../util";
import { SET_RENDER, ONE_PANEL_SURVEY_CONTENT } from "../../constants";

const useOnePanelSurveyMutationObserver = (props) => {
  useEffect(() => {
    if (!props.definition) return;

    const {
      definition,
      handleOnClickCondition,
      handleOnHoverCondition,
      hasHovered,
      hasClicked,
      hasMouseLeftViewport,
      hasTimedOut,
      dispatch,
    } = props;

    const {
      onePanelSurveyDisplayConditions: {
        ...restOnePanelSurveyDisplayConditions
      },
    } = definition[ONE_PANEL_SURVEY_CONTENT];

    const engineOptions = {
      clickCallback: handleOnClickCondition,
      hoverCallback: handleOnHoverCondition,
    };

    //this section sets up the mutation observer
    // this will run everytime there is a change on the dom
    const target = document.documentElement || document.body;

    const config = {
      attributes: true,
      childList: true,
      subtree: true,
    };

    const subscriber = () => {
      const isRender = conditionsEngine(restOnePanelSurveyDisplayConditions, {
        ...engineOptions,
        isHoveredTrue: hasHovered.current,
        isClickTrue: hasClicked.current,
        isMouseLeftViewportTrue: hasMouseLeftViewport.current,
        isIdle: hasTimedOut.current,
      });

      dispatch({
        type: SET_RENDER,
        payload: isRender,
      });
    };

    const observer = new MutationObserver(subscriber);

    observer.observe(target, config);

    return () => {
      observer.disconnect();
    };
  }, []);
};

export default useOnePanelSurveyMutationObserver;
